import React, { useCallback } from 'react';
import PrevIcon from '@moda/icons/prev-16';
import NextIcon from '@moda/icons/next-16';
import { Text, Clickable, LoadingBalls } from '@moda/om';
import classNames from 'classnames';
import { useUrlParams } from '../../../hooks/useUrlParams';
import { useLook } from '../useLook';

import './LooksCarouselItemHeaderNavigation.scss';

interface Props {
  className?: string;
}

export const LooksCarouselItemHeaderNavigation: React.FC<Props> = ({ className }) => {
  const {
    params: { look: lookId },
    addParams
  } = useUrlParams();
  const { position, numberOfLooks, nextLookId, prevLookId, loading } = useLook(lookId);

  const addLookParam = useCallback(
    (id: number | null | undefined) => {
      if (!id) return;

      addParams({ look: id.toString() });
    },
    [addParams]
  );

  return (
    <nav className={classNames('LooksCarouselItemHeaderNavigation', className)}>
      <Clickable disabled={!prevLookId} onClick={() => addLookParam(prevLookId)}>
        <PrevIcon />
      </Clickable>

      {loading && <LoadingBalls width={20} height={20} />}

      {!loading && <Text>{`LOOK ${position} / ${numberOfLooks}`}</Text>}

      <Clickable disabled={!nextLookId} onClick={() => addLookParam(nextLookId)}>
        <NextIcon />
      </Clickable>
    </nav>
  );
};
